import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFix = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M13.423 3.423a3.1 3.1 0 0 0-2.94 4.375.75.75 0 0 1-.153.84L6.746 12.22a.75.75 0 0 1-.582.218c-.644-.045-1.563.107-1.933 1.008-.279.681-.223 1.25-.013 1.668.213.425.616.756 1.146.897a1.65 1.65 0 0 0 1.122-.085 2 2 0 0 0 1.066-1.125c.108-.294.155-.61.089-.929a.75.75 0 0 1 .208-.687L8.94 12.11l2.393-2.516a.75.75 0 0 1 .852-.166c.536.242 1.014.267 1.682.145a3.1 3.1 0 0 0 2.541-3.166l-1.483 1.484a1.39 1.39 0 0 1-1.949 0l-.005-.005-1.032-1.032a1.39 1.39 0 0 1 0-1.948l.005-.005.007-.007 1.472-1.472Zm-.94-1.428a4.6 4.6 0 0 1 2.72.335.75.75 0 0 1 .22 1.214L13.087 5.88l.864.864 2.338-2.337a.75.75 0 0 1 1.214.22 4.6 4.6 0 0 1-3.366 6.422c-.702.128-1.362.146-2.057-.062l-2.06 2.166-.017.018-.836.822c.03.495-.067.948-.206 1.326a3.5 3.5 0 0 1-1.878 1.984 3.15 3.15 0 0 1-2.104.157c-.915-.244-1.682-.838-2.1-1.673-.423-.843-.462-1.868-.035-2.91.663-1.616 2.166-1.928 3.07-1.944L8.926 7.92a4.6 4.6 0 0 1 3.557-5.926Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFix;
